import React from 'react';
import Button from '@material-ui/core/Button';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { GridBodyType } from 'enums';

import { GridRightPanelProps } from '../grid-types';
import { useActionButtons, useBodyButtons } from '../grid-hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRightPanelRoot: {
      minHeight: 'calc(100vh - 140px)',
      height: '100%',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    rightPanelTitle: {
      fontSize: '14px !important',
      fontWeight: ('600 !important' as unknown) as 600,
      letterSpacing: '1px !important',
      textTransform: 'uppercase',
      margin: '16px !important',
    },
    rightPanelIcon: {
      width: 30,
      height: 30,
      margin: 15,
    },
    buttons: {
      padding: 16,
      width: '100%',
    },
    activeNavigationButton: {
      alignSelf: 'baseline',
      width: '100%',
      fontWeight: 'bold',
    },
    navigationButton: {
      alignSelf: 'baseline',
      width: '100%',
    },
    actionButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function GridRightPanel(props: GridRightPanelProps) {
  const classes = useStyles();
  const { gridBody, setGridBody, gridConfig, item } = props;

  const bodyButtons = useBodyButtons(gridConfig);
  const ActionButtons = useActionButtons(gridConfig);

  // this will cause that the right panel button will have access to item data.
  if (!item) {
    return <></>;
  }

  return (
    <div className={classes.gridRightPanelRoot}>
      <LibraryBooksIcon className={classes.rightPanelIcon} />
      {!!bodyButtons.length && (
        <div className={classes.buttons}>
          <Button
            component="span"
            variant="text"
            className={
              gridBody === GridBodyType.DETAIL
                ? classes.activeNavigationButton
                : classes.navigationButton
            }
            onClick={() => setGridBody?.(GridBodyType.DETAIL)}
          >
            Detail
          </Button>
          {bodyButtons.map(({ id, label }) => (
            <Button
              key={id}
              component="span"
              variant="text"
              className={
                gridBody === id
                  ? classes.activeNavigationButton
                  : classes.navigationButton
              }
              onClick={() => setGridBody?.(id)}
            >
              {label}
            </Button>
          ))}
        </div>
      )}
      <div className={classes.buttons}>
        <ActionButtons {...props} />
      </div>
    </div>
  );
}
